import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getTenantFeatures } from '../lib/api';

/**
 * LMS master-switch guard: when `lms_enabled` is off, the learning pages do
 * not exist for this tenant — bounce to the dashboard rather than render an
 * empty shell (the sidebar entry is hidden too; this catches deep links).
 */
export function RequireLms({ children }: { children: React.ReactNode }) {
  const featuresQuery = useQuery({
    queryKey: ['tenant-features'],
    queryFn: getTenantFeatures,
    staleTime: 60_000,
    retry: false,
  });
  if (featuresQuery.isLoading) return null;
  if (featuresQuery.data?.lms_enabled !== true) return <Navigate to="/" replace />;
  return <>{children}</>;
}
